export const FILTER_KEY_BY_PARAM = {
  bussines: "instances",
  keyword: "keyword",
  market_segment: "marketSegments",
};